import {DHXView} from "dhx-optimus";

import {MenuView} 	from "views/menu.js";

import {FindView} 	from "views/water/find.js";


export class TopMenuView extends DHXView{

	render(){
		var self = this;
		
		self.ui = self.root.attachLayout("2E");
		self.ui.setOffsets({
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		});
		self.ui.setAutoSize("a;b", "a");
 	
		self.ui.cells("b").conf.size.h = 35;
		self.ui.setSizes();
		
		self.ui.forEachItem( cell =>{
			cell.hideHeader();
			cell.fixSize(true, true);
		});
		self.ui.setSeparatorSize(0, 0);
		
		
		var cell_a = self.ui.cells("a");
		cell_a.cell.childNodes[cell_a.conf.idx.cont].style.backgroundColor = "transparent";	
		
		//-----
		
		self.show(MenuView, self.ui);
		
		//self.ui.dhxWins.attachViewportTo(self.ui.cells("a").cell);
 
		
		self.attachEvent("MenuClick", (id) => {

			self.onMenuClick(id);
		});		
	
		
	}
	
	onMenuClick(id) {
		var self = this;
		
		//dhtmlx.alert(id + " button was clicked")
		console.log(id + " button was clicked");
		
		if(id == "t1") {
			var find = new FindView();
			self.show(find, self.ui.cells("a"));
		}
	
	}
	
}


// WEBPACK FOOTER //
// ./sources/views/topmenu.js